import React from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface DashboardHeaderProps {
  userPlan: string | null;
}

export function DashboardHeader({ userPlan }: DashboardHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-8 rounded-xl text-white shadow-lg">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold mb-2">Bem-vindo ao seu Painel</h1>
          <p className="text-blue-50">Gerencie suas cartas e acompanhe seu progresso</p>
        </div>
        <Button 
          onClick={() => navigate('/admin/escrever-carta')}
          className="bg-white text-purple-600 hover:bg-blue-50 hover:text-purple-700"
        >
          <Plus className="mr-2 h-4 w-4" /> Escrever nova carta
        </Button>
      </div>
    </div>
  );
}